import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TikTokWhite = forwardRef<SVGSVGElement, IconProps>(({ size = 20 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 38 36"
      fill="none"
      ref={forwardedRef}
    >
      <g filter="url(#a)">
        <path
          fill="#fff"
          fillOpacity=".3"
          d="M12.293 20.867c.118-.978.52-1.526 1.275-2.087 1.082-.76 2.433-.33 2.433-.33v-2.552c.329-.009.658.01.982.058v3.284s-1.35-.43-2.432.33c-.756.561-1.158 1.11-1.276 2.088-.003.531.096 1.226.555 1.826a4.495 4.495 0 0 1-.347-.199c-1.011-.68-1.195-1.698-1.19-2.418Zm10.27-9.688c-.744-.815-1.025-1.639-1.127-2.217h.936s-.186 1.517 1.174 3.008l.019.02a5.396 5.396 0 0 1-1.002-.81Zm4.51 2.312v3.218s-1.194-.047-2.079-.272c-1.234-.314-2.027-.797-2.027-.797s-.548-.344-.593-.368v6.645a6.44 6.44 0 0 1-.41 2.065c-.403 1.008-1.026 1.67-1.14 1.805 0 0-.757.895-2.092 1.497-1.204.544-2.26.53-2.577.544 0 0-1.827.072-3.47-.996a6.884 6.884 0 0 1-.992-.797l.009.006c1.644 1.068 3.47.996 3.47.996.317-.014 1.373 0 2.577-.543 1.334-.603 2.092-1.497 2.092-1.497.113-.136.738-.797 1.14-1.806.308-.77.41-1.695.41-2.065v-6.644c.045.024.592.369.592.369s.794.482 2.029.796c.884.225 2.078.272 2.078.272v-2.521c.409.091.757.116.983.093Z"
        />
        <path
          fill="#fff"
          d="M26.09 13.398v2.52s-1.194-.046-2.079-.271c-1.234-.315-2.028-.797-2.028-.797s-.548-.344-.592-.369v6.646a6.44 6.44 0 0 1-.41 2.065c-.403 1.008-1.026 1.67-1.14 1.805 0 0-.758.895-2.093 1.497-1.203.544-2.26.53-2.576.544 0 0-1.826.072-3.47-.996l-.009-.006a6.283 6.283 0 0 1-.49-.532 6.311 6.311 0 0 1-.926-1.615c-.13-.375-.404-1.276-.366-2.148.066-1.54.607-2.484.75-2.721a6.466 6.466 0 0 1 1.458-1.707 6.145 6.145 0 0 1 1.732-.983 6.024 6.024 0 0 1 2.15-.432v2.551s-1.352-.428-2.433.33c-.756.562-1.157 1.11-1.275 2.088-.005.72.179 1.739 1.19 2.418.117.075.233.141.346.2.177.229.392.429.636.591.987.625 1.814.668 2.872.263.705-.272 1.236-.883 1.482-1.56.155-.424.153-.85.153-1.29V8.962h2.461c.102.578.384 1.402 1.128 2.217.298.308.634.58 1.001.81.108.113.662.667 1.373 1.007.368.176.755.31 1.155.402Zm-16.793 9.71v.002l.062.166c-.007-.02-.03-.078-.062-.168Z"
        />
        <path
          fill="#fff"
          d="M13.85 16.33a6.151 6.151 0 0 0-1.731.984 6.468 6.468 0 0 0-1.457 1.71c-.144.236-.685 1.182-.751 2.721-.037.873.236 1.773.366 2.149v.002c.082.214.402.97.927 1.613.152.186.316.363.49.531a6.731 6.731 0 0 1-1.473-1.323 6.327 6.327 0 0 1-.924-1.608v-.003c-.13-.375-.405-1.276-.367-2.15.066-1.539.608-2.484.751-2.72a6.459 6.459 0 0 1 1.457-1.71 6.139 6.139 0 0 1 1.732-.984 6.131 6.131 0 0 1 1.222-.344 6.332 6.332 0 0 1 1.91-.027v.727a6.032 6.032 0 0 0-2.151.433Z"
        />
        <path
          fill="#fff"
          d="M21.436 8.962h-2.462V21.49c0 .44 0 .865-.152 1.289-.249.677-.778 1.288-1.483 1.56-1.058.407-1.885.362-2.871-.263a2.654 2.654 0 0 1-.638-.59c.84.43 1.593.423 2.525.064.705-.271 1.234-.883 1.482-1.56.155-.423.153-.849.153-1.289V8.171h3.399s-.038.311.047.791Zm4.654 3.739v.697a5.51 5.51 0 0 1-1.152-.402c-.711-.34-1.265-.894-1.373-1.006.125.08.256.151.39.216.864.413 1.716.537 2.135.495Z"
        />
      </g>
      <defs>
        <filter
          id="a"
          width="46"
          height="46"
          x="-5"
          y="-3"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_5481_113009" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_5481_113009" result="shape" />
        </filter>
      </defs>
    </svg>
  )
})
